import Action from "csi/def/Action";
import declare from "dojo/_base/declare";
import ViewRef from "csi/def/ViewRef";
import RefContainer from "csi/heading/RefContainer";
import reflection from "csi/reflection";
import lang from "dojo/_base/lang";
import xml from "csi/xml";

const COLOR_ALLOCATION_WIP = "ColorAllocationStatus:Allocation WIP";
const BOM_PRODUCT_COLOR_VIEW = "BomProductColorForColorAllocation";
const PRODUCT_COLOR_VIEW = "ProductColors";
const PRODUCT_SOURCE_TYPE = "ProductSource";

const OnlyForProductColorsView = declare(RefContainer, {
    
	_getStoreAction: function(ctx, h, bAll) {
		let isAllocated = false;
		const bomRevision = ctx.view.getViewNode();
		const bom = ctx.cache.getNode(bomRevision.__Parent__);
		let product = ctx.cache.getNode(bom.__Parent__);
		if (product?.$Type === PRODUCT_SOURCE_TYPE) {
			const productSourcing = ctx.cache.getNode(product.__Parent__);
			product = ctx.cache.getNode(productSourcing?.__Parent__);
		}
		if (product?.ColorAllocationStatus === COLOR_ALLOCATION_WIP && xml.isValidURL(bom.ForProductSource)) {
			isAllocated = true;
		}
		var viewRef = lang.mixin(new ViewRef(), {
			m_id : isAllocated ? BOM_PRODUCT_COLOR_VIEW : PRODUCT_COLOR_VIEW,
			m_path : reflection.PATH_PARENT,
		});
		return lang.mixin(new Action(), {
			m_viewRef : viewRef,
		});
	},
});

export = OnlyForProductColorsView;